import { render, staticRenderFns } from "./RobotReplyContainer.vue?vue&type=template&id=fe60cf8c&scoped=true"
import script from "./RobotReplyContainer.vue?vue&type=script&lang=js"
export * from "./RobotReplyContainer.vue?vue&type=script&lang=js"
import style0 from "./RobotReplyContainer.vue?vue&type=style&index=0&id=fe60cf8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe60cf8c",
  null
  
)

export default component.exports